export const THEME_PRESETS = [
  { name: "Maroon & Blush", colors: { primary: "#5C162E", secondary: "#C7386B", accent: "#D4AF37", text: "#4A0E22", bg: "#FBEEF0" } },
  { name: "Emerald & Gold", colors: { primary: "#0B3D2E", secondary: "#1E7A5A", accent: "#D4AF37", text: "#0B3D2E", bg: "#EDF5F0" } },
  { name: "Royal Navy", colors: { primary: "#141B4D", secondary: "#3A4CA0", accent: "#C9A227", text: "#141B4D", bg: "#EEF0FA" } },
  { name: "Dusty Rose", colors: { primary: "#7A3B4A", secondary: "#B96A78", accent: "#C99E6A", text: "#5A2A36", bg: "#FBF0F1" } },
  { name: "Midnight & Gold", colors: { primary: "#1A1A1A", secondary: "#4A4A4A", accent: "#D4AF37", text: "#1A1A1A", bg: "#F4F1EA" } },
  { name: "Teal & Copper", colors: { primary: "#0E4C4C", secondary: "#1F7A7A", accent: "#C77B3B", text: "#0E4C4C", bg: "#EAF4F3" } },
];

export const BG_PRESETS = [
  "https://images.unsplash.com/photo-1763560836989-d3636e2f82d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1700608277871-a16cfe788293?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1744056083470-3b7a223c5801?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1601662528567-526cd06f6582?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.pexels.com/photos/5102228/pexels-photo-5102228.jpeg?auto=compress&cs=tinysrgb&w=1200",
];

export const MUSIC_PRESETS = [
  { name: "Soft Instrumental", url: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-8.mp3" },
  { name: "Gentle Piano", url: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3" },
];

export const FONT_DISPLAY_OPTIONS = [
  "Cormorant Garamond",
  "Playfair Display",
  "EB Garamond",
  "Cinzel",
  "Marcellus",
  "Italiana",
  "Cormorant SC",
];

export const FONT_NAMES_OPTIONS = [
  "Cormorant Garamond",
  "Playfair Display",
  "Cinzel",
  "Marcellus",
  "Great Vibes",
  "Tangerine",
  "Pinyon Script",
  "Parisienne",
  "Sacramento",
];
